import React from 'react';
import styled from 'styled-components';
import { COLOR_RED, COLOR_WHITE } from '@common/assets/styles/colors';

type TInputErrorProps = {
  error: string;
  className?: string;
};

const InputErrorSC = styled.div`
  position: relative;

  .triangle {
    position: absolute;
    top: -7px;
    left: 20px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid ${COLOR_RED};
  }

  .error-box {
    min-height: 28px;
    border-radius: 8px;
    background-color: ${COLOR_RED};

    display: flex;
    align-items: center;

    color: ${COLOR_WHITE};
    padding: 8px 20px;
    font-weight: bold;
    line-height: 12px;
  }
`;

const InputError: React.FC<TInputErrorProps> = ({ error, className = '' }: TInputErrorProps) => {
  return (
    <InputErrorSC className={className}>
      <div className="triangle" />
      <div className="error-box">{error}</div>
    </InputErrorSC>
  );
};

export default InputError;
